import React from 'react';
import { func, number, shape, bool } from 'prop-types';

import { OverlayViewPortal, InfowindowInstance } from '../lib';
import InfowindowItem from '../../layout/renderer/map/infowindow-card-content';
import { INFOWINDOW_MARGIN, INFOWINDOW_MARGIN_PRICE_BASE, INFOWINDOW_MARGIN_PER_CHAR } from '../lib/constants';
import { ZOOM_LEVELS } from '../lib/controls/constants';

const IMAGE_OPTIONS = { lazyload: 'off', mounted: true };

const Infowindow = ({ containerMeasurements, content, index, map, onClick, onHover, zoom }) => {
  const { latitude, longitude, price: { map_price: { text: formattedPrice } = {} } = {} } = content;

  const calculateMargin = (currentZoom, priceText) => {
    if (currentZoom < ZOOM_LEVELS.DEFAULT) {
      return INFOWINDOW_MARGIN;
    }

    return INFOWINDOW_MARGIN_PRICE_BASE + (priceText ? priceText.length : 0) * INFOWINDOW_MARGIN_PER_CHAR;
  };

  return (
    <OverlayViewPortal id="infowindow-portal">
      <InfowindowInstance
        map={map}
        lat={latitude}
        lng={longitude}
        containerMeasurements={containerMeasurements}
        onMouseOver={() => onHover(index, [content])}
        onMouseOut={() => onHover(null, null)}
        customMargin={calculateMargin(zoom, formattedPrice)}
      >
        <InfowindowItem
          item={content}
          options={IMAGE_OPTIONS}
          onClick={(event) => {
            event.preventDefault();
            onClick(index);
          }}
        />
      </InfowindowInstance>
    </OverlayViewPortal>
  );
};

Infowindow.propTypes = {
  containerMeasurements: shape().isRequired,
  content: shape({
    latitude: number.isRequired,
    longitude: number.isRequired,
    viewed: bool,
  }).isRequired,
  index: number,
  map: shape().isRequired,
  zoom: number,
  onClick: func.isRequired,
  onHover: func.isRequired,
};

export default Infowindow;
